import AddRowButton from './AddRowButton';
import DeleteRowButton from './DeleteRowButton';
import EditRowButton from './EditRowButton';
import DeleteTemplateButton from './DeleteTemplateButton';
import EditTemplateButton from './EditTemplateButton';
import NewTemplateButton from './NewTemplateButton';

export default {
  AddRowButton,
  DeleteRowButton,
  EditRowButton,
  DeleteTemplateButton,
  EditTemplateButton,
  NewTemplateButton,
};
